export class Department {
  constructor(
    private id: DepartmentId,
    public name: string
  ) { }

  public getId(): DepartmentId {
    return this.id;
  }
}

export type DepartmentId = string;



// WEBPACK FOOTER //
// /dist/src/app/user/work-record/department.model.ts